import { render, staticRenderFns } from "./TrainingStylistsDetails.vue?vue&type=template&id=c5759ece&"
import script from "./TrainingStylistsDetails.vue?vue&type=script&lang=js&"
export * from "./TrainingStylistsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports